import { render, staticRenderFns } from "./TarifasTarifarios.vue?vue&type=template&id=cd01afd0"
import script from "./TarifasTarifarios.vue?vue&type=script&lang=js"
export * from "./TarifasTarifarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports